export const roleList = "ROLE_LIST";